module.exports = __webpack_public_path__ + "static/media/nptel.240a642e.png";